export default {
  admin: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Customer Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-drop',
      children: [
        {
          name: 'Verified Customers',
          url: '/customers/active-customers',
          icon: 'icon-puzzle'
        },
        {
          name: 'Unverified Customers',
          url: '/customers/inactive-customers',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      title: true,
      name: 'Loans Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Loans',
      url: '/loans',
      icon: 'icon-puzzle',
      children: [
        // {
        //   name: 'All Loans',
        //   url: '/loans/all-loans',
        //   icon: 'icon-puzzle'
        // },
        {
          name: 'Active Loans',
          url: '/loans/active-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Approved Loans',
          url: '/loans/approved-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Pending Loans',
          url: '/loans/pending-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Declined Loans',
          url: '/loans/declined-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Disbursement List',
          url: '/loans/disbursement-list',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      divider: true
    },
    {
      title: true,
      name: 'Notification Module'
    },
    {
      name: 'Transactions',
      url: '/transactions',
      icon: 'icon-star',
      children: [
        {
          name: 'Activity Logs',
          url: '/transactions/activity-logs',
          icon: 'icon-star'
        }
      ]
    },
    {
      divider: true
    },
    {
      title: true,
      name: 'Settings Module'
    },
    {
      name: 'Settings',
      url: '/configurations',
      icon: 'icon-star',
      children: [
        {
          name: 'Users',
          url: '/configurations/users',
          icon: 'icon-star'
        },
        {
          name: 'System Settings',
          url: '/configurations/system-settings',
          icon: 'icon-star'
        },
        // {
        //   name: 'Roles and Permission',
        //   url: '/configurations/roles-permissions',
        //   icon: 'icon-star'
        // }
      ]
    }
  ],
  risk: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Customer Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-drop',
      children: [
        {
          name: 'Verified Customers',
          url: '/customers/active-customers',
          icon: 'icon-puzzle'
        },
        {
          name: 'Unverified Customers',
          url: '/customers/inactive-customers',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      title: true,
      name: 'Loans Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Loans',
      url: '/loans',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Active Loans',
          url: '/loans/active-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Approved Loans',
          url: '/loans/approved-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Pending Loans',
          url: '/loans/pending-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Declined Loans',
          url: '/loans/declined-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Disbursement List',
          url: '/loans/disbursement-list',
          icon: 'icon-puzzle'
        }
      ]
    },
  ],
  sales: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Customer Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-drop',
      children: [
        {
          name: 'Verified Customers',
          url: '/customers/active-customers',
          icon: 'icon-puzzle'
        },
        {
          name: 'Unverified Customers',
          url: '/customers/inactive-customers',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      title: true,
      name: 'Loans Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Loans',
      url: '/loans',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Active Loans',
          url: '/loans/active-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Approved Loans',
          url: '/loans/approved-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Pending Loans',
          url: '/loans/pending-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Declined Loans',
          url: '/loans/declined-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Disbursement List',
          url: '/loans/disbursement-list',
          icon: 'icon-puzzle'
        }
      ]
    },
  ],
  operations: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Customer Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-drop',
      children: [
        {
          name: 'Verified Customers',
          url: '/customers/active-customers',
          icon: 'icon-puzzle'
        },
        {
          name: 'Unverified Customers',
          url: '/customers/inactive-customers',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      title: true,
      name: 'Loans Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Loans',
      url: '/loans',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Active Loans',
          url: '/loans/active-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Approved Loans',
          url: '/loans/approved-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Pending Loans',
          url: '/loans/pending-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Declined Loans',
          url: '/loans/declined-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Disbursement List',
          url: '/loans/disbursement-list',
          icon: 'icon-puzzle'
        }
      ]
    },
  ],
  collections: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Customer Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-drop',
      children: [
        {
          name: 'Verified Customers',
          url: '/customers/active-customers',
          icon: 'icon-puzzle'
        },
        {
          name: 'Unverified Customers',
          url: '/customers/inactive-customers',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      title: true,
      name: 'Loans Module',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Loans',
      url: '/loans',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Active Loans',
          url: '/loans/active-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Approved Loans',
          url: '/loans/approved-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Pending Loans',
          url: '/loans/pending-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Declined Loans',
          url: '/loans/declined-loans',
          icon: 'icon-puzzle'
        },
        {
          name: 'Disbursement List',
          url: '/loans/disbursement-list',
          icon: 'icon-puzzle'
        }
      ]
    },
  ],
  finance: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
  ],
}
